import React, { useEffect } from 'react';
import {NavLink} from 'react-router-dom';

const Navbar = () => {

  const showMenu = () => {
    document.getElementById('mobile-menu').classList.replace("hidden", "flex");
  }

  const hideMenu = () => {
    document.getElementById('mobile-menu').classList.replace("flex", "hidden");
  }

  return (
    <nav role="navigation" className="sticky top-0">
      <div className="lg:flex hidden flex-row justify-around bg-black py-4">
        <div>
          <NavLink exact to="/" className="text-white mr-6 text-lg hover:text-gray-400" activeStyle={{color: '#F0860C'}}>Home</NavLink>
          <NavLink exact to="/about" className="text-white mr-6 text-lg hover:text-gray-400"
                   activeStyle={{color: '#F0860C'}}>About</NavLink>
          <NavLink exact to='/projects' className="text-white text-lg hover:text-gray-400"
                   activeStyle={{color: '#F0860C'}}>Projects</NavLink>
        </div>
        <div>
          <NavLink exact to="/contact" className="text-white text-lg hover:text-gray-400" activeStyle={{color: '#F0860C'}}>Contact</NavLink>
        </div>
      </div>

      <div className="lg:hidden block relative">
        <i aria-label="Menu" id="menu-opener" className="fas fa-bars fa-2x p-4 bg-red-800" onClick={showMenu}>
        </i>
        <div id="mobile-menu" className="hidden flex-col justify-around items-center h-screen w-full absolute top-0 right-0 z-10 bg-black transform transition duration-300 ease-in-out ">
          <NavLink exact to="/" className="text-5xl mb-4 hover:text-gray-400" activeStyle={{color: '#F0860C'}}>Home</NavLink>
          <NavLink exact to="/about" className="text-5xl mb-4 hover:text-gray-400" activeStyle={{color: '#F0860C'}}>About</NavLink>
          <NavLink exact to="/projects" className="text-5xl mb-4 hover:text-gray-400" activeStyle={{color: '#F0860C'}}>Projects</NavLink>
          <NavLink exact to="/contact" className="text-5xl mb-4 hover:text-gray-400" activeStyle={{color: '#F0860C'}}>Contact</NavLink>
          <button onClick={hideMenu}><i aria-label="close" className="fas fa-times fa-3x">
          </i></button>
        </div>
      </div>

    </nav>
  );
};

export default Navbar;
